import React , {Component} from "react";
import Link from 'gatsby-link';
import './navigationMenu.css';

const ListLink = props =>
  <li onClick={props.scrollTo}> 
    <Link className="resourse" to={props.to}>
      {props.children}
    </Link>
  </li>

class NavigationList extends React.Component{
  constructor(){
    super();
  }
  render(){
    return(
      <ul className="navigation_menu_items">
        <ListLink  to="/" > <i className="fa fa-home navigation"></i>Home</ListLink>
        <ListLink  to="/articles/"><i className="resourses-icon navigation"></i>Articles</ListLink>
        <ListLink  to="/contact/"><i className="fa fa-envelope navigation"></i> Contact</ListLink>
    </ul>
    )
  }
}

export default NavigationList;



// WEBPACK FOOTER //
// ./src/components/navigationMenu/navigationList.js